<h1 mat-dialog-title class="heading">Add New Options</h1>
<div mat-dialog-content class="content-container" *ngIf="form?.controls">
    <form [formGroup]="form" class="add-options-form">
        <mat-form-field
            [matTooltip]="optionsToolTip">
                                <textarea
                                    #message
                                    [attr.data-testid]="'dropdown_options'"
                                    formControlName="options"
                                    matInput
                                    placeholder="Add option values separated by comma"
                                    (focusout)="optionsValidation()"
                                ></textarea>
            <mat-error *ngIf="form.controls['options'].invalid && !specialCharactersFound">
                Add values separated by comma.
            </mat-error>
            <mat-error *ngIf="form.controls['options'].invalid && specialCharactersFound">
                Special characters are not allowed.
            </mat-error>
        </mat-form-field>
    </form>
</div>
<div class="action-container">
    <button
        mat-raised-button
        type="button"
        (click)="onNoClick()">Cancel
    </button>
    <button
        *ngIf="form?.controls"
        matTooltip="Return to the form to save your new options"
        (click)="continue()"
        [disabled]="this.form.invalid || !this.form.dirty"
        mat-raised-button
        type="button"
    >Continue
    </button>
</div>
